import Vue from "vue";

import moment from "moment";

Vue.filter("formatDate", function (value, format) {
  if (!value) return "";
  else if (value == "N/A") return "N/A";
  // return moment("2024-06-07 12:26:49 AM").format("DD-MM-YY");
  // return moment(value).format(format || "DD-MMM-YYYY HH:mm:ss");
  return moment(value).format(format || "DD-MM-YYYY hh:mm:ss A");
});

Vue.filter("formatTime", function (value, format) {
  if (!value) return "";
  else if (value == "N/A") return "N/A";
  // return moment("2024-06-07 12:26:49 AM").format("DD-MM-YY");
  // return moment(value).format(format || "DD-MMM-YYYY HH:mm:ss");
  return moment(value).format(format || "hh:mm:ss A");
});

Vue.filter("currencyFormat", function (value) {
  const cur = localStorage.getItem("selectedCurrency");
  const sym = cur;
  return value.replace(/Currency/g, sym);
});

Vue.filter("currencySign", function () {
  const cur = localStorage.getItem("selectedCurrency");
  return cur || ""; // Return the currency or an empty string
});

//
Vue.filter("commaFormat", function (val, c = true) {
  const cur = localStorage.getItem("selectedCurrency");
  const amount = Number(val);
  if (isNaN(amount)) {
    return c ? `${cur} 0` : "0";
  }

  const formatted = amount.toLocaleString("en-PK");

  return c ? `${cur} ${formatted || 0}` : formatted || 0; // Return the formatted currency or an empty string
});

Vue.filter("returnAlpha", function (val, upperCase = true) {
  const alpha = ["a", "b", "c", "d", "e"];
  return upperCase ? alpha[val].toUpperCase() : alpha[val];
});
